import { useState } from 'react';
import { Filters } from './types';

type UseCasinoFilters = (initialFilters: Filters) => {
  filters: Filters;
  setFilter: (attr: keyof Filters, value: string) => void;
};

const useCasinoFilters: UseCasinoFilters = (initialFilters) => {
  const [filters, setFilters] = useState(initialFilters);

  const submit = (newFilters: Filters = filters) => {
    const event = new CustomEvent('casinoSearch', { detail: newFilters });
    document.dispatchEvent(event);
  };

  const setFilter = (filter: keyof Filters, value: string) => {
    setFilters((prev) => {
      const newFilters = { ...prev, [filter]: value };
      submit(newFilters);
      return newFilters;
    });
  };

  return {
    filters,
    setFilter,
  };
};

export default useCasinoFilters;
